// extracted by mini-css-extract-plugin
module.exports = {"google":"Socials_google__HDxeX","facebook":"Socials_facebook__112m-","label":"Socials_label__28c-C","icon":"Socials_icon__2Gprx"};